
import { supabase } from "@/integrations/supabase/client";
import { FamilyAdmin } from "@/types/database";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";

export const familyAdminService = {
  /**
   * Check if user is the admin of the family by comparing registration_family_id with current_family_id
   * Uses is_family_admin database function
   */
  isHouseholdAdmin: withErrorHandling(
    async (userId: string): Promise<boolean> => {
      // Call the database function
      const { data, error } = await supabase
        .rpc("is_family_admin", { p_user_id: userId });
      
      if (error) throw error;

      return data || false;
    },
    "Failed to check if user is family admin"
  ),

  /**
   * Get the family admin details for a specific family
   * The admin is the user whose registration_family_id matches the family ID
   */
  getHouseholdAdmin: withErrorHandling(
    async (familyId: string): Promise<FamilyAdmin | null> => {
      // Find the user whose registration_family_id matches this family ID
      const { data: profileData, error: profileError } = await supabase
        .from("profiles")
        .select("id, first_name, last_name")
        .eq("registration_family_id", familyId)
        .single();
      
      if (profileError) {
        if (profileError.code === 'PGRST116') {
          // No match found - no admin
          return null;
        }
        throw profileError;
      }

      return {
        first_name: profileData.first_name,
        last_name: profileData.last_name,
        id: profileData.id
      };
    },
    "Failed to get household admin"
  )
};
